'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Logger = require('@/libs/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _CommonLayout = require('./CommonLayout');

var _CommonLayout2 = _interopRequireDefault(_CommonLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('Startup/kiwiBnc');

exports.default = {
    components: {
        StartupLayout: _CommonLayout2.default
    },
    data: function data() {
        return {
            loading: false,
            username: '',
            password: '',
            statusMessage: ''
        };
    },
    computed: {
        greetingText: function greetingText() {
            var greeting = _state2.default.settings.startupOptions.greetingText;
            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
        },
        buttonText: function buttonText() {
            if (this.loading) {
                return '';
            }

            var greeting = _state2.default.settings.startupOptions.buttonText;
            return typeof greeting === 'string' ? greeting : this.$t('start_button');
        }
    },
    methods: {
        startUp: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var _this = this;

                var bncnet, cleanUpEvents, onRegistered, onError, onClose;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.statusMessage = this.$t('logging_in');
                                this.loading = true;

                                bncnet = this.getBncNetwork();

                                cleanUpEvents = function cleanUpEvents() {
                                    bncnet.ircClient.off('registered', onRegistered);
                                    bncnet.ircClient.off('irc error', onError);
                                    bncnet.ircClient.off('close', onClose);
                                };

                                onRegistered = function () {
                                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                                        var bncNetworks, i, network, buffers;
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        cleanUpEvents();

                                                        _context.next = 3;
                                                        return bncnet.ircClient.bnc.getNetworks();

                                                    case 3:
                                                        bncNetworks = _context.sent;
                                                        i = 0;

                                                    case 5:
                                                        if (!(i < bncNetworks.length)) {
                                                            _context.next = 22;
                                                            break;
                                                        }

                                                        network = bncNetworks[i];

                                                        network.buffers = [];
                                                        _context.prev = 8;
                                                        _context.next = 11;
                                                        return bncnet.ircClient.bnc.getBuffers(network.name);

                                                    case 11:
                                                        buffers = _context.sent;

                                                        network.buffers = buffers;
                                                        _context.next = 18;
                                                        break;

                                                    case 15:
                                                        _context.prev = 15;
                                                        _context.t0 = _context['catch'](8);

                                                        log.error(_context.t0);

                                                    case 18:

                                                        _this.addNetworkToState(network);

                                                    case 19:
                                                        i++;
                                                        _context.next = 5;
                                                        break;

                                                    case 22:

                                                        _this.monitorNetworkChanges(bncnet, bncNetworks);
                                                        _this.$refs.layout.close();

                                                    case 24:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this, [[8, 15]]);
                                    }));

                                    return function onRegistered() {
                                        return _ref2.apply(this, arguments);
                                    };
                                }();

                                onError = function onError(event) {
                                    cleanUpEvents();
                                    _this.statusMessage = _this.$t('invalid_login');
                                    _this.loading = false;
                                };

                                onClose = function onClose(event) {
                                    cleanUpEvents();
                                    _this.statusMessage = _this.$t('invalid_login');
                                    _this.loading = false;
                                };

                                bncnet.ircClient.once('registered', onRegistered);
                                bncnet.ircClient.once('irc error', onError);
                                bncnet.ircClient.once('close', onClose);
                                bncnet.ircClient.connect();

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function startUp() {
                return _ref.apply(this, arguments);
            }

            return startUp;
        }(),

        getBncNetwork: function getBncNetwork() {
            var bnc = _state2.default.setting('bnc');

            if (bnc.network) {
                bnc.username = this.username;
                bnc.password = this.password;
                return bnc.network;
            }

            var options = _state2.default.settings.startupOptions;

            bnc.active = true;
            bnc.server = options.server || '';
            bnc.port = options.port || 6667;
            bnc.tls = !!options.tls;
            bnc.username = this.username;
            bnc.password = this.password;

            var bncnet = _state2.default.addNetwork('bnccontrol', this.username, {
                server: bnc.server,
                port: bnc.port,
                tls: bnc.tls
            });

            bnc.network = bncnet;

            return bncnet;
        },

        addNetworkToState: function addNetworkToState(network) {
            var net = _state2.default.addNetwork(network.name, network.nick, {
                server: network.host,
                port: network.port,
                tls: network.tls,
                password: network.password,
                bncname: network.name,
                username: network.user
            });

            network.buffers.forEach(function (buffer) {
                var newBuffer = _state2.default.addBuffer(net.id, buffer.name);
                if (buffer.joined) {
                    newBuffer.enabled = true;
                }
                if (buffer.seen) {
                    newBuffer.last_read = new Date(buffer.seen).getTime();
                }
            });
        },

        monitorNetworkChanges: function monitorNetworkChanges(bncNet, bncNetworks) {
            var existingNets = (0, _create2.default)(null);
            function rememberNetworks() {
                _state2.default.networks.forEach(function (network) {
                    if (!network.connection.bncname) {
                        return;
                    }

                    existingNets[network.connection.bncname] = {
                        name: network.connection.bncname,
                        host: network.connection.server,
                        port: network.connection.port,
                        tls: network.connection.tls,
                        password: network.connection.password,
                        nick: network.nick,
                        username: network.username
                    };
                });
            }

            rememberNetworks();

            var saveState = function saveState(newVal) {
                _state2.default.networks.forEach(function (network) {
                    if (network.name === 'bnccontrol') {
                        return;
                    }

                    var bncName = network.connection.bncname;
                    var current = existingNets[bncName] || {};
                    var tags = {};

                    if (network.connection.server !== current.host) {
                        tags.host = network.connection.server;
                    }
                    if (network.connection.port !== current.port) {
                        tags.port = network.connection.port;
                    }
                    if (network.connection.tls !== current.tls) {
                        tags.tls = network.connection.tls;
                    }
                    if (network.connection.password !== current.password) {
                        tags.password = network.connection.password;
                    }
                    if (network.nick !== current.nick) {
                        tags.nick = network.nick;
                    }
                    if (network.username !== current.username) {
                        tags.user = network.username;
                    }

                    if (!current.name && tags.host) {
                        network.connection.bncname = network.name;
                        bncNet.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password);
                    } else if (current.name) {
                        bncNet.ircClient.bnc.saveNetwork(bncName, tags);
                    }
                });

                rememberNetworks();
            };

            var debouncedSaveState = _lodash2.default.debounce(saveState, 2000);

            _state2.default.$watch('networks', debouncedSaveState, { deep: true });

            _state2.default.$on('network.connecting', function (event) {
                saveState();

                var netName = event.network.connection.bncname;
                var networkFromBnc = _lodash2.default.find(bncNetworks, { name: netName });
                if (networkFromBnc && !networkFromBnc.connected) {
                    bncNet.ircClient.raw('BOUNCER connect ' + netName);
                }
            });

            _state2.default.$on('network.new', function (event) {
                var currentNum = 1;
                var existingNet = true;
                while (existingNet) {
                    existingNet = _lodash2.default.find(_state2.default.networks, { name: 'Network' + currentNum });
                    if (!existingNet) {
                        event.network.name = 'Network' + currentNum;
                    }

                    currentNum++;
                }
            });

            _state2.default.$on('network.removed', function (event) {
                bncNet.ircClient.bnc.removeNetwork(event.network.connection.bncname);
            });

            _state2.default.$on('buffer.close', function (event) {
                var buffer = event.buffer;
                var network = event.buffer.getNetwork();
                var bncName = network.connection.bncname;

                if (bncName) {
                    bncNet.ircClient.bnc.closeBuffer(bncName, buffer.name);
                }
            });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["KiwiBnc"]
window._kiwi_exports.components.startups.KiwiBnc = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/startups/KiwiBnc.vue
// module id = 2SpE
// module chunks = 1